var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * h5 结果页面模版
 */
import React, { useEffect, useImperativeHandle, useRef, useState, forwardRef, } from 'react';
import VideoPlayer from '../../VideoPlayer';
import Modal from '../../Modal';
import style from './index.module.scss';
import { generateResultImage } from '../../../utils/image-handler';
import Toast from '../../Toast';
import { mergeCssStyles } from '../../../utils/common';
import useLongPress from '../../../hooks/longPress';
import SwitchButton from '../../switch-button';
const ResultPageBaby = ({ videoFrameImgUrl, isVideo, resultUrl, posterImgUrl, resultPanel, shareLoadingContent, actionArea, downloadImage, shareLinkImage, downloadVideo, replayBtnUrl, shareResultImage, styleCustom, handleReplayClick, handleShareClick, handleSaveVideoResultImg, showCustomContent, showBackgroundUrl, isNeedAutoPlayHiddenBtn, onLongPressImage, children, switchVideo, selectBoyUrl, selectGirlUrl, loadingUrl, isShowSwitch, switchOn, }, ref) => {
    const videoRef = useRef(null);
    const [toastMsg, setToastMsg] = useState('');
    const [toastVisible, setToastVisible] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);
    const mergeStyle = styleCustom ? mergeCssStyles(style, styleCustom) : style;
    const [isShowVideoDownload, setShowDownload] = useState(false);
    useEffect(() => {
        var _a;
        document.addEventListener('visibilitychange', () => {
            var _a;
            if (document.visibilityState !== 'visible') {
                (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
            }
        });
        try {
            (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.ui.pageVisibility((visibility) => {
                var _a, _b;
                if (visibility) {
                    (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
                    return;
                }
                (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.pause();
            });
        }
        catch (e) {
            console.log(e);
        }
        // 暂停播放
        return () => {
            var _a;
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        };
    }, []);
    const saveQQImage = (url) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const imgBase64 = yield generateResultImage(url || resultUrl);
            window.mqq.invoke('media', 'saveImage', {
                content: imgBase64,
            }, (data) => {
                console.log(data);
                if (data.retCode === 0) {
                    // 保存成功
                    console.log('图片保存成功');
                    setToastMsg('保存成功');
                    setToastVisible(true);
                }
                else {
                    // 保存失败
                    console.log('图片保存失败');
                    setToastMsg('保存失败, 请稍后再试吧');
                    setToastVisible(true);
                }
            });
        }
        catch (e) {
            setToastMsg('保存失败');
            setToastVisible(true);
        }
    });
    const shareQQVideo = () => {
        if (!isVideo || !window.mqq) {
            return;
        }
        setShareLoading(true);
        // 下载视频
        return new Promise(resolve => {
            window.mqq.invoke('aecamera', 'downloadVideo', {
                videoUrl: resultUrl,
            }, () => {
                console.log('下载完成');
                resolve(true);
                setShareLoading(false);
                // 唤起分享
                window.mqq.invoke('aecamera', 'shareVideo', { videoUrl: resultUrl });
            });
        });
    };
    const saveQQVideo = (resUrl) => {
        return new Promise(resolve => {
            window.mqq.invoke('aecamera', 'downloadVideo', {
                videoUrl: resUrl || resultUrl,
            }, () => {
                console.log('下载完成');
                // 必须调用分享视频才可以下载视频
                setShowDownload(true);
                setTimeout(() => {
                    setShowDownload(false);
                }, 1500);
                resolve(true);
                setTimeout(() => {
                    window.mqq.invoke('aecamera', 'shareVideo', { videoUrl: resultUrl });
                }, 1000);
            });
        });
    };
    const shareQQImage = () => {
        if (isVideo || !window.mqq) {
            return;
        }
        setShareLoading(true);
        return new Promise((resolve, reject) => {
            window.mqq.invoke('aecamera', 'sharePic', { picUrl: resultUrl }, (data) => {
                // 图片分享存在loading状态
                data.succeeded ? resolve(true) : reject(false);
            });
        });
    };
    /**向外暴露如下方法 */
    useImperativeHandle(ref, () => ({
        /**
         * 下载图片-保存图片方法(QQ)
         */
        saveQQImage,
        /**
         * 分享视频
         */
        shareQQVideo,
        /**
         * 分享图片
         */
        shareQQImage,
        /**
         * QQ内保存视频
         *
         */
        saveQQVideo,
        /**
         * 获取视频 ref
         */
        getVideoRef: () => {
            return videoRef;
        },
    }));
    const getShareLoading = () => {
        return shareLoadingContent ? (shareLoadingContent) : (React.createElement("div", { className: mergeStyle['loading-modal'] },
            React.createElement("div", null, "\u5206\u4EAB\u4E2D...")));
    };
    const handleImageLongPress = useLongPress(() => {
        onLongPressImage();
    });
    const getLoadingModal = () => (React.createElement("div", { className: mergeStyle['download'] },
        React.createElement("img", { src: loadingUrl, alt: "" })));
    const getResultPanel = () => resultPanel !== null && resultPanel !== void 0 ? resultPanel : (React.createElement("div", { className: mergeStyle[`show-panel${isVideo ? '' : '-image'}`] },
        isVideo ? (React.createElement("div", { className: mergeStyle['video-panel'] },
            React.createElement(VideoPlayer, { videoUrl: resultUrl, posterImgUrl: posterImgUrl, ref: videoRef, isNeedAutoPlayHiddenBtn: isNeedAutoPlayHiddenBtn }))) : (React.createElement("div", { className: mergeStyle['image-panel'] },
            React.createElement("img", Object.assign({ src: resultUrl, alt: "", className: mergeStyle['result-image'] }, handleImageLongPress)))),
        videoFrameImgUrl ? (React.createElement("img", { src: videoFrameImgUrl, className: mergeStyle['video-mask'], alt: "" })) : null,
        showCustomContent));
    const getActionPanel = () => {
        if (actionArea)
            return actionArea;
        // 默认操作区域：下载图片/分享链接
        return (React.createElement("div", { className: mergeStyle[`action-panel${isVideo ? '' : '-image'}`] },
            React.createElement(React.Fragment, null,
                React.createElement("img", { "data-btn-id": "result#share", className: mergeStyle['download-image'], src: shareResultImage, alt: "", onClick: handleShareClick }),
                React.createElement("img", { "data-btn-id": "result#download-result-image", className: mergeStyle['share-btn'], src: downloadImage, alt: "", onClick: handleSaveVideoResultImg }),
                React.createElement("img", { "data-btn-id": "result#replay", className: mergeStyle['replay-btn'], src: replayBtnUrl, alt: "", onClick: handleReplayClick }))));
    };
    return (React.createElement("div", { className: mergeStyle['result-page'] },
        React.createElement("div", { className: mergeStyle['show-container'] },
            showBackgroundUrl ? (React.createElement("img", { className: mergeStyle['show-container-bg'], src: showBackgroundUrl, alt: "alt" })) : null,
            getResultPanel(),
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    marginTop: '5px',
                } }, isShowSwitch ? (React.createElement(SwitchButton, { switchOn: switchOn, onClick: switchVideo, selectBoyUrl: selectBoyUrl, selectGirlUrl: selectGirlUrl })) : null),
            getActionPanel()),
        children,
        React.createElement(Modal, { content: getShareLoading(), visible: shareLoading, isClosedByClick: false, hideModal: () => {
                setShareLoading(false);
            } }),
        React.createElement(Modal, { content: getLoadingModal(), visible: isShowVideoDownload, isClosedByClick: false, hideModal: () => setToastVisible(false) }),
        React.createElement(Toast, { msg: toastMsg, visible: toastVisible, hideToast: () => {
                setToastVisible(false);
            } })));
};
export default forwardRef(ResultPageBaby);
